import React, { useRef } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { gql, useQuery } from '@apollo/client';
import { Skeleton } from '@material-ui/lab';

const LoanZoneDialog = ({ open, handleClose, handleLoanZoneSelection }) => {
  const inputRef = useRef();

  const { data } = useQuery(gql`
    query getLoanZonesForSelect {
      loanZones {
        guid
        publicName
        publicDescription
        publicAddress
        publicContactPhone
        publicContactEmail
      }
    }
  `);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Átvételi pont kiválasztása</DialogTitle>
      <DialogContent>
        {!data ? (
          <Skeleton />
        ) : (
          <TextField
            variant={'outlined'}
            margin={'dense'}
            fullWidth
            select
            defaultValue={data?.loanZones[0]?.guid}
            label={'Átvételi pont'}
            inputRef={inputRef}
          >
            {data?.loanZones?.map(loanZone => (
              <MenuItem value={loanZone.guid} key={loanZone.guid}>
                {loanZone.publicName}
              </MenuItem>
            )) ?? <MenuItem value={'loading'}>Betöltés ...</MenuItem>}
          </TextField>
        )}
      </DialogContent>
      <DialogActions>
        <Button color={'secondary'} variant={'contained'} onClick={handleClose}>
          Bezár
        </Button>
        <Button
          color={'primary'}
          variant={'contained'}
          onClick={() =>
            handleLoanZoneSelection(
              data?.loanZones?.find(
                loanZone => loanZone.guid === inputRef.current.value
              )
            )
          }
        >
          Foglalás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LoanZoneDialog;
